<template>
  <div>
    <feather-icon
      icon="SettingsIcon"
      class="mr-3"
      @click="open = !open"
    />


    <vs-popup class="toolbar-popup" :title="$t('설정')" :active.sync="open" position="top" :class="{ 'mobile-popup': isMobile }">
      <!-- Desktop 레이아웃 -->
      <div v-if="!isMobile" class="w-full p-3 grid grid-cols-3 gap-2">
        <i18n-drop-down />
        <vs-button class="px-2 py-1" color="primary" type="border" @click="openLink">{{ $t('QR스캔') }}</vs-button>
        <vs-button v-if="projectId" class="px-2 py-1" color="primary" type="border" @click="openQrCode">{{ $t('QR코드') }}</vs-button>
      </div>

      <!-- Mobile 레이아웃 -->
      <div v-else class="w-full p-4 flex flex-col gap-3">
        <div class="mobile-i18n-container">
          <i18n-drop-down />
        </div>
        <vs-button class="w-full h-12 text-lg font-medium" color="primary" type="border" @click="openLink">{{ $t('QR스캔') }}</vs-button>
        <vs-button v-if="projectId" class="w-full h-12 text-lg font-medium" color="primary" type="border" @click="openQrCode">{{ $t('QR코드') }}</vs-button>
      </div>
    </vs-popup>


    <qr-scan-manager ref="qrScanManager" :user-id="userInfo.id || userInfo.user_id || 'guest'" />

    <!-- QR 코드 다이얼로그 -->
    <q-r-auth-dialog ref="authDialog" :user-id="userInfo.id" />
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import QRAuthDialog from "@/components/QRAuthDialog.vue";
import QrScanManager from "@/layouts/components/navbar/components/qr-scan-manager/QrScanManager.vue";
import QrScanBoard from "@/layouts/components/navbar/components/qr-scan-manager/QrScanBoard.vue";
import NavigationDialog from "@/components/dialog/NavigationDialog.vue";
import I18nDropDown from "@/layouts/components/navbar/components/I18n.vue";

export default {
  components: {
    I18nDropDown,
    NavigationDialog, QrScanBoard,
    QrScanManager, QRAuthDialog,
    VuePerfectScrollbar
  },
  data () {
    return {
      open: false,
      windowWidth: window.innerWidth
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
    isMobile() {
      return this.windowWidth < 768;
    }
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    close() {
      document.getElementById('text')
    },
    openLink() {
      this.open = false;
      // QR 스캔 다이얼로그 열기
      this.$refs.qrScanManager.open();
    },

    openQrCode() {
      this.open = false;
      // QR 코드 다이얼로그 열기
      this.$refs.authDialog.openDialog();
    },
  }
}

</script>
<style>
.toolbar-popup {
  @apply items-start
}


/* 모바일에서 언어 선택 드롭다운 전체 폭 사용 */
.mobile-i18n-container {
  width: 100%;
}

.mobile-i18n-container .vs-dropdown {
  width: 100% !important;
  margin: 0 !important;
}

.mobile-i18n-container .vs-dropdown .cursor-pointer {
  margin: 0 !important;
}

.mobile-i18n-container .i18n-locale {
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
  min-height: 48px !important;
  align-items: center !important;
  font-size: 1.125rem !important;
  margin: 0 !important;
  box-sizing: border-box !important;
}

/* 모바일에서 vs-button 터치 친화적 높이 */
@media (max-width: 767px) {
  .vs-button {
    min-height: 48px !important;
  }

  /* 모바일에서 언어 드롭다운 강제 전체 폭 적용 */
  .mobile-i18n-container * {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .mobile-i18n-container .vs-dropdown,
  .mobile-i18n-container .cursor-pointer,
  .mobile-i18n-container .i18n-locale {
    width: 100% !important;
    max-width: 100% !important;
  }
}
</style>
